import { useEffect, useState } from 'react';
import { FormStepConfig } from '../../editor/features/clickToMessengerAds/components/AdConfigDetail/FormStepContainer/FormStepContainer';

export const useFormSteps = (
  configs: FormStepConfig[],
  isCollapsed: (index: number) => boolean,
  nextClicked: number,
  shouldCollapsePreviousStep?: boolean,
): [boolean[], (steps: boolean[]) => void] => {
  const previousStepIndex = shouldCollapsePreviousStep
    ? nextClicked
    : nextClicked - 1;
  const [stepsStatus, setStepsStatus] = useState<boolean[]>([]);

  useEffect(() => {
    const initialStepsStatus = configs.map((config, index) => {
      return !isCollapsed(index);
    });
    setStepsStatus(initialStepsStatus);
  }, []);

  useEffect(() => {
    if (nextClicked >= 0) {
      const updatedStepsStatus = configs.map((config, index) => {
        if (index < previousStepIndex) {
          return false;
        }
        return !isCollapsed(index);
      });
      setStepsStatus(updatedStepsStatus);
    }
  }, [nextClicked]);

  return [stepsStatus, setStepsStatus];
};
